export default __webpack_public_path__ + "fonts/SanFranciscoDisplay-Regular.7daa5d2065790dd9468f65adc6d78ef9.eot";